var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Microsoft"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microsoft",
    clipPath: "url(#clip-Microsoft)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(51 28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-109 -7465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56 160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "windows-_174_",
    "data-name": "windows-[#174]",
    d: "M13.146,7289.43c.005,2,.011,5.4.016,8.04,3.614.49,7.228.99,10.836,1.53,0-3.15,0-6.29,0-9.29-3.617,0-7.233-.28-10.852-.28M4,7289.44v6.78c2.726.37,5.452.72,8.172,1.12,0-2.62,0-5.25,0-7.87-2.724,0-5.447-.04-8.17-.03m0-7.6v6.77c2.726.01,5.452-.03,8.177-.03q0-3.93,0-7.86-4.092.51-8.172,1.12m20,6.63c-3.612.02-7.224.07-10.838.08q0-3.99,0-7.98,5.411-.825,10.836-1.57c0,3.16,0,6.31,0,9.47",
    fill: "#2e78d5",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.345e6eeed1ad384220df9520816e1333.svg";
export { ForwardRef as ReactComponent };